export default "__VITE_ASSET__Cs7F5SUS__"